/** Etiqueta legible para meses con XML pendiente (p. ej. «Ene 2024, Feb 2024 y Mar 2024»). */
export function formatMissingMonthsPhrase(months, max = 8) {
  const labels = (months || [])
    .slice(0, max)
    .map((m) => (m.label || m.month || "").trim())
    .filter(Boolean);
  if (labels.length === 0) return null;
  if (labels.length === 1) return labels[0];
  if (labels.length === 2) return `${labels[0]} y ${labels[1]}`;
  return `${labels.slice(0, -1).join(", ")} y ${labels[labels.length - 1]}`;
}
